import React, { useEffect, useRef } from 'react';
import ReactPlayer from 'react-player';
import { X } from 'lucide-react';
interface VideoModalProps {
  isOpen: boolean;
  onClose: () => void;
  videoUrl: string;
}
const VideoModal: React.FC<VideoModalProps> = ({
  isOpen,
  onClose,
  videoUrl
}) => {
  const modalRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    const handleClickOutside = (e: MouseEvent) => {
      if (modalRef.current && !modalRef.current.contains(e.target as Node)) {
        onClose();
      }
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.addEventListener('mousedown', handleClickOutside);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.removeEventListener('mousedown', handleClickOutside);
      document.body.style.overflow = 'auto';
    };
  }, [isOpen, onClose]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" data-id="element-563">
      <div ref={modalRef} className="relative bg-white rounded-xl shadow-2xl w-full max-w-2xl overflow-hidden" data-id="element-564">
        <button onClick={onClose} className="absolute top-4 right-4 z-10 bg-black/50 hover:bg-black/70 text-white p-2 rounded-full transition-colors" aria-label="Close video" data-id="element-565">
          <X size={20} data-id="element-566" />
        </button>
        <div className="aspect-video w-full" data-id="element-567">
          <ReactPlayer url={videoUrl} width="100%" height="100%" playing={isOpen} controls={true} config={{
          vimeo: {
            playerOptions: {
              responsive: true,
              autoplay: true
            }
          }
        }} data-id="element-568" />
        </div>
      </div>
    </div>;
};
export default VideoModal;